module.exports = {
	"is_by_homeowner": {
		"required": false,
		"type": "term",
		"value": null
	},
	"repair": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"from_mcad_km": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"include_new_moscow": {
		"required": false,
		"type": "term",
		"value": null
	},
	"realty_user_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_furniture": {
		"required": false,
		"type": "term",
		"value": null
	},
	"children": {
		"required": false,
		"type": "term",
		"value": null
	},
	"tv": {
		"required": false,
		"type": "term",
		"value": null
	},
	"company_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"lk_offer_statuses": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"saved_search_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bs_center": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"description_include": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"sub_agent_ids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"bbox": {
		"required": false,
		"type": "term",
		"value": null
	},
	"geo": {
		"required": false,
		"type": "geo",
		"value": null
	},
	"categories": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"garage": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bathhouse": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_price_reduced": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_manual": {
		"required": false,
		"type": "term",
		"value": null
	},
	"page": {
		"required": false,
		"type": "term",
		"value": null
	},
	"commission_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"good_ecology": {
		"required": false,
		"type": "term",
		"value": null
	},
	"creation_date": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"has_kitchen_furniture": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_water": {
		"required": false,
		"type": "term",
		"value": null
	},
	"category": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"random_sort": {
		"required": false,
		"type": "term",
		"value": null
	},
	"with_corpuses": {
		"required": false,
		"type": "term",
		"value": null
	},
	"pets": {
		"required": false,
		"type": "term",
		"value": null
	},
	"internet": {
		"required": false,
		"type": "term",
		"value": null
	},
	"dish_washer": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_washer": {
		"required": false,
		"type": "term",
		"value": null
	},
	"only_foot": {
		"required": false,
		"type": "term",
		"value": null
	},
	"offset": {
		"required": false,
		"type": "term",
		"value": null
	},
	"kids": {
		"required": false,
		"type": "term",
		"value": null
	},
	"from_offrep": {
		"required": false,
		"type": "term",
		"value": null
	},
	"zalog": {
		"required": false,
		"type": "term",
		"value": null
	},
	"region": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"land_status2": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"is_basement": {
		"required": false,
		"type": "term",
		"value": null
	},
	"show_inactive": {
		"required": false,
		"type": "term",
		"value": null
	},
	"electricity": {
		"required": false,
		"type": "term",
		"value": null
	},
	"description_exclude": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"builders_ids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"publish_period": {
		"required": false,
		"type": "term",
		"value": null
	},
	"developer_sort_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"foot_min": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"cl": {
		"required": false,
		"type": "term",
		"value": null
	},
	"object_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"floorn": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"bath": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_semibasement": {
		"required": false,
		"type": "term",
		"value": null
	},
	"quality": {
		"required": false,
		"type": "term",
		"value": false
	},
	"wp": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_drainage": {
		"required": false,
		"type": "term",
		"value": null
	},
	"house_year": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"sort": {
		"required": false,
		"type": "term",
		"value": null
	},
	"wc_site": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_fridge": {
		"required": false,
		"type": "term",
		"value": null
	},
	"status_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"for_day": {
		"required": false,
		"type": "term",
		"value": "!1"
	},
	"gas": {
		"required": false,
		"type": "term",
		"value": null
	},
	"precision": {
		"required": false,
		"type": "term",
		"value": null
	},
	"phone": {
		"required": false,
		"type": "term",
		"value": null
	},
	"heating_source_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"prepay": {
		"required": false,
		"type": "term",
		"value": null
	},
	"id_user": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bs_center_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"shower": {
		"required": false,
		"type": "term",
		"value": null
	},
	"limit": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bs_center_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"house_material": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"total_area": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"site": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"currency": {
		"required": false,
		"type": "term",
		"value": 2
	},
	"conditioner": {
		"required": false,
		"type": "term",
		"value": null
	},
	"id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"skipids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"floor": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"realty_sort_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_video": {
		"required": false,
		"type": "term",
		"value": null
	},
	"enable_autotest_offers": {
		"required": false,
		"type": "term",
		"value": null
	},
	"composition": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"with_layout": {
		"required": false,
		"type": "term",
		"value": null
	},
	"_type": "suburbanrent",
	"newbuildings_search": {
		"required": false,
		"type": "term",
		"value": null
	},
	"rent_period_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"price": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"is_first_floor": {
		"required": false,
		"type": "term",
		"value": null
	},
	"with_neighbors": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_in_hidden_base": {
		"required": false,
		"type": "term",
		"value": null
	},
	"pool": {
		"required": false,
		"type": "term",
		"value": null
	},
	"land_status": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"engine_version": {
		"required": false,
		"type": "term",
		"value": 2
	},
	"contact": {
		"required": false,
		"type": "term",
		"value": null
	},
	"billing_package_region_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"my_offers_search_text": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bedroom_total": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/serp/autogenerated-default-filters/suburbanrent.json
// module id = 510
// module chunks = 0